var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnsFacebook = function SvgSnsFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.41 9.452.467-3.04H5.96V4.44c0-.833.407-1.643 1.714-1.643H9V.205S7.798 0 6.644 0C4.242 0 2.67 1.456 2.67 4.093v2.319H0v3.04h2.67v7.353h3.286V9.452H8.41Z",
    fill: "current"
  })));
};
export default SvgSnsFacebook;